<template>
  <AdminColorForm :id="route.params.id" @close="router.push({name:'admin-colors'})" />
</template>
<script setup lang="ts">
const route = useRoute()
const router = useRouter()
</script>
